import { Component } from '@angular/core';
import { Theme, THEMES } from 'main/enums/theme.enum';
import { UserSettingsService } from 'main/services/user-settings.service';
@Component({
    selector: 'theme-editor',
    templateUrl: './theme-editor.component.html',
    styleUrls: ['./theme-editor.component.scss'],
})
export class ThemeEditorComponent {


    showUpdate = false;

    get selectedTheme(){
        return this.userSettingsService.CurrentTheme;
    }

    get typeOfTheme(){
        return typeof this.userSettingsService.CurrentTheme;
    }

    themes = THEMES.map(t => ({ value: t.value, label: t.label }));

    constructor(private userSettingsService: UserSettingsService) { }

    setTheme(theme: Theme) {
        this.userSettingsService.setTheme(theme);
        // show update for 3 seconds
        this.showUpdate = true;
        setTimeout(() => {
            this.showUpdate = false;
        }, 3000);
    }
}
